import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { ErrorOutline as ErrorOutlineIcon } from '@mui/icons-material'
import { Box, Button, Typography } from '@mui/material'

type Props = {
  message: string
  retryAction: () => void
}

export const ErrorMessage: FC<Props> = props => {
  const { message, retryAction } = props

  const { t } = useTranslation()

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 400,
        width: '100%',
        p: 3,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 3,
          maxWidth: 500,
          textAlign: 'center',
        }}
      >
        <ErrorOutlineIcon sx={{ fontSize: 48, color: 'error.main' }} />
        <Typography color='error' sx={{ fontWeight: 500 }} variant='subtitle1'>
          {message}
        </Typography>
        <Button size='large' variant='contained' onClick={retryAction}>
          {t('retry')}
        </Button>
      </Box>
    </Box>
  )
}
